import React from "react";
import { Link } from "react-router-dom";
import { Play, FileText, Download } from "lucide-react";
import { API_BASE, resolveFileUrl } from "../lib/api";

export default function SermonCard({ s, variant = "list" }) {
  const date = s.published_at ? new Date(s.published_at).toLocaleDateString("es-PY", { day: "2-digit", month: "short", year: "numeric" }) : "";
  if (variant === "row") {
    return (
      <Link to={`/predicas/${s.id}`} className="block p-card p-5 md:p-6 group" data-testid={`sermon-row-${s.id}`}>
        <div className="flex items-center gap-5">
          <div className="shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-full bg-[#F5B841] text-[#1B1308] flex items-center justify-center shadow-[0_8px_24px_-8px_rgba(245,184,65,0.6)] group-hover:scale-[1.06] transition">
            <Play size={26} fill="currentColor" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex flex-wrap items-center gap-2 text-sm text-[#55594F] mb-1.5">
              {s.series && <span className="badge-soft">{s.series}</span>}
              {s.bible_reference && <span className="font-mono text-[#A36A00] font-semibold">{s.bible_reference}</span>}
              {date && <span>· {date}</span>}
            </div>
            <h3 className="font-display text-xl md:text-2xl font-bold text-[#1B1C1A] leading-tight tracking-tight line-clamp-2 group-hover:text-[#A36A00] transition">{s.title}</h3>
          </div>
          <div className="hidden md:flex gap-2">
            <a href={`${API_BASE}/sermons/${s.id}/pdf`} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} className="pill pill-sm pill-outline" data-testid={`btn-pdf-${s.id}`}>
              <FileText size={16} /> PDF
            </a>
          </div>
        </div>
      </Link>
    );
  }
  return (
    <article className="p-card p-6 flex flex-col gap-4 h-full" data-testid={`sermon-card-${s.id}`}>
      <div className="flex items-center gap-2 text-sm text-[#55594F]">
        {s.series && <span className="badge-soft" data-testid={`sermon-series-${s.id}`}>{s.series}</span>}
        {date && <span>· {date}</span>}
      </div>
      <h3 className="font-display text-2xl font-bold text-[#1B1C1A] leading-tight tracking-tight" data-testid={`sermon-title-${s.id}`}>
        <Link to={`/predicas/${s.id}`} className="hover:text-[#A36A00] transition">{s.title}</Link>
      </h3>
      {s.bible_reference && (
        <div className="font-mono text-sm text-[#A36A00] font-semibold" data-testid={`sermon-ref-${s.id}`}>
          {s.bible_reference} <span className="text-[#55594F] font-normal">({s.bible_version})</span>
        </div>
      )}
      {s.summary && <p className="text-base text-[#3F433C] line-clamp-3 leading-relaxed">{s.summary}</p>}
      <div className="mt-auto flex flex-wrap gap-2 pt-2">
        <Link to={`/predicas/${s.id}`} className="pill pill-sm pill-gold" data-testid={`btn-listen-${s.id}`}>
          <Play size={16} fill="currentColor" /> Escuchar
        </Link>
        <a href={`${API_BASE}/sermons/${s.id}/pdf`} target="_blank" rel="noreferrer" className="pill pill-sm pill-outline" data-testid={`btn-pdf-card-${s.id}`}>
          <FileText size={16} /> PDF
        </a>
        {s.audio_url && (
          <a href={resolveFileUrl(s.audio_url)} download className="pill pill-sm pill-outline" data-testid={`btn-mp3-${s.id}`}>
            <Download size={16} /> MP3
          </a>
        )}
      </div>
    </article>
  );
}
